import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import Timeline from 'components/Timeline'

import { orderStates } from 'utils/resources'
import { getGroupedOrdersByDate } from 'utils/Orders/getGroupedOrdersByDate'
import { ReactComponent as IconCalendar } from 'assets/icons/IconCalendar.svg'

const OrderStateHistory = forwardRef(({ order, id }, ref) => {
  const orderStatesWithConvertedState = order?.stateTransitions?.map(
    (stateTransition) => ({
      ...stateTransition,
      displayState: orderStates[stateTransition?.state] ?? '',
    })
  )

  // Sort order states by id in descending order
  const sortedOrderStatesDescending =
    orderStatesWithConvertedState?.sort((a, b) => {
      return b.id - a.id
    }) ?? []

  const groupedOrderStatesWithConvertedState = getGroupedOrdersByDate(
    sortedOrderStatesDescending
  )

  if (isEmpty(groupedOrderStatesWithConvertedState)) {
    return null
  }

  return (
    <section className="order-details__section -pb-0" id={id} ref={ref}>
      <header className="order-details__header -vertical -smaller-margin">
        <h4 className="order-details__main-header">Order State History</h4>
      </header>
      <Timeline>
        {Object.entries(groupedOrderStatesWithConvertedState)?.map(
          ([date, orders], index) => {
            return (
              <li className="timeline__item" key={index}>
                <p className="timeline__date">
                  <span className="timeline__calendar-icon">
                    <IconCalendar />
                  </span>
                  {date}
                </p>
                <ul className="timeline__details-list">
                  {orders?.map(
                    ({ state, displayState, reason, dateAndTime, id }) => {
                      return (
                        <li key={id} className="timeline__detail">
                          <p className="timeline__header">
                            <span
                              className={`timeline__dot -dot-${state}`}
                            ></span>
                            <span>{displayState ?? ''}</span>
                            <span className="timeline__status-date">
                              {dateAndTime}
                            </span>
                          </p>
                          <p className="timeline__comment">{`Reason: ${
                            reason ?? ''
                          }`}</p>
                        </li>
                      )
                    }
                  )}
                </ul>
              </li>
            )
          }
        )}
      </Timeline>
    </section>
  )
})

OrderStateHistory.propTypes = {
  id: PropTypes.string,
  order: PropTypes.object,
}

OrderStateHistory.displayName = 'TransactionHistory'

export default OrderStateHistory
